import React from 'react';
import { Provider } from 'react-redux';
import store from '../store/store';
import PropTypes from 'prop-types';

const ReduxWrapper = ({ element }) => <Provider store={store}>{element}</Provider>;

export default ReduxWrapper;

ReduxWrapper.propTypes = {
  element: PropTypes.string
};
